module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button py-2 px-6 rounded-full text-center font-bold inline-block border-2 border-white cursor-pointer",
    class: _vm.classList,
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3b3ae64","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/csf-button.vue
// module id = 172
// module chunks = 0